
export default {
  name: "GenerateReportIcon",
};
